import React from 'react';
import { string, func, bool } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';

import './style.scss';

const TextButton = ({
    text,
    onClick = () => null,
    disabled = false
}) => (
    <Button className="text-button"
        onClick={onClick}
        disabled={disabled}>
        <I18n k={text}/>
    </Button>
);

TextButton.propTypes = {
    text: string.isRequired,
    onClick: func,
    disabled: bool
};

export default TextButton;
